import { checkLocalStore } from "@/services/firebase/getLocalStore";

class LoginService {
    public prepareLoginResponse: any = {}

    public setPrepareLoginResponse(value: any) {
        this.prepareLoginResponse = value
    }

    public getPrepareLoginResponse(): any {
        return this.prepareLoginResponse
    }

    public agg_feature(feature: any = {}, features: any = {}) {
        if (features.length === 0) {
            features = []
        }
        if (feature.size !== undefined && feature.size !== 0) {
            features.push(Object.fromEntries(feature))
        }
        return features
    }

    public extract_key(sub_seq) {
        const feature = new Map()
        let source_down: any = {}
        let source_up: any = {}
        let target_down: any = {}
        let target_up: any = {}
        for (const [step_idx, step] of sub_seq.entries()) {
            if (step.type === "down") {
                if (Object.keys(source_down).length === 0) {
                    source_down = step
                    continue
                }
                if (Object.keys(target_down).length === 0) {
                    target_down = step
                    continue
                }
            }
            if (step.type === "up") {
                if (step_idx === 0) {
                    return {}
                }
                if ((Object.keys(source_up).length === 0) && (Object.keys(source_down).length !== 0) && (step.keycode === source_down.keycode)) {
                    source_up = step
                    continue
                }
                if ((Object.keys(target_up).length === 0) && (Object.keys(target_down).length !== 0) && (step.keycode === target_down.keycode)) {
                    target_up = step
                    continue
                }
            }
            if ((Object.keys(source_down).length !== 0) && (Object.keys(source_up).length !== 0) && (Object.keys(target_down).length !== 0) && (Object.keys(target_up).length !== 0)) {
                break
            }
        }
        if ((Object.keys(source_down).length === 0) || (Object.keys(source_up).length === 0) || (Object.keys(target_down).length === 0) || (Object.keys(target_up).length === 0)) {
            return {}
        }
        feature.set("DD", target_down.time - source_down.time)
        feature.set("DU", target_up.time - source_down.time)
        feature.set("UD", target_down.time - source_up.time)
        feature.set("UU", target_up.time - source_up.time)
        feature.set("Hold", source_up.time - source_down.time)
        return feature
    }

    public extract(raw_seq) {
        raw_seq = this.clean_raw_seq(raw_seq)
        let features = []
        for (let i = 0; i < raw_seq.length; i++) {
            const raw_seq_tmp = raw_seq
            features = this.agg_feature(this.extract_key(raw_seq_tmp.slice(i, raw_seq.length)), features)
        }
        return features
    }

    public clean_raw_seq(data) {
        data.sort((a, b) => a.time - b.time);
        let i = 0
        while (i < data.length) {
            if (!("keycode" in data[i])) {
                data.splice(i, 1);
                continue
            }
            i += 1
        }
        return data
    }

    public async getMetaData() {
        let binding: any
        let orientation: string = ""

        // get device
        binding = await checkLocalStore()

        // get orientation
        if (window.matchMedia("(orientation: portrait)").matches) {
            orientation = "portrait"
        } else {
            orientation = "landscape"
        }

        // screen
        let screenSize = "";
        if (screen.width) {
            const width = (screen.width) ? screen.width : "";
            const height = (screen.height) ? screen.height : "";
            screenSize += "" + width + " x " + height;
        }

        // browser
        const nVer = navigator.appVersion;
        const nAgt = navigator.userAgent;
        let browser = navigator.appName;
        let version = '' + parseFloat(nVer);
        let ix;

        // Opera
        if (nAgt.indexOf('Opera') !== -1) {
            browser = 'Opera';
            version = nAgt.substring(nAgt.indexOf('Opera') + 6);
            if (nAgt.indexOf('Version') !== -1) {
                version = nAgt.substring(nAgt.indexOf('Version') + 8);
            }
        }
        if (nAgt.indexOf('OPR') !== -1) {
            browser = 'Opera';
            version = nAgt.substring(nAgt.indexOf('OPR') + 4);
        } else if (nAgt.indexOf('Edge') !== -1) {
            browser = 'Microsoft Legacy Edge';
            version = nAgt.substring(nAgt.indexOf('Edge') + 5);
        } else if (nAgt.indexOf('Edg') !== -1) {
            browser = 'Microsoft Edge';
            version = nAgt.substring(nAgt.indexOf('Edg') + 4);
        } else if (nAgt.indexOf('MSIE') !== -1) {
            browser = 'Microsoft Internet Explorer';
            version = nAgt.substring(nAgt.indexOf('MSIE') + 5);
        } else if (nAgt.indexOf('Chrome') !== -1) {
            browser = 'Chrome';
            version = nAgt.substring(nAgt.indexOf('Chrome') + 7);
        } else if (nAgt.indexOf('Safari') !== -1) {
            browser = 'Safari';
            version = nAgt.substring(nAgt.indexOf('Safari') + 7);
            if (nAgt.indexOf('Version') !== -1) {
                version = nAgt.substring(nAgt.indexOf('Version') + 8);
            }
        } else if (nAgt.indexOf('Firefox') !== -1) {
            browser = 'Firefox'
            version = nAgt.substring(nAgt.indexOf('Firefox') + 8);
        } else if (nAgt.indexOf('Trident/') !== -1) {
            browser = 'Microsoft Internet Explorer';
            version = nAgt.substring(nAgt.indexOf('rv:') + 3);
        } else if ((nAgt.lastIndexOf(' ') + 1) < nAgt.lastIndexOf('/')) {
            browser = nAgt.substring(nAgt.lastIndexOf(' ') + 1, nAgt.lastIndexOf('/'));
            version = nAgt.substring(nAgt.lastIndexOf('/') + 1);
            if (browser.toLowerCase() === browser.toUpperCase()) {
                browser = navigator.appName;
            }
        }
        // trim the version string
        ix = version.indexOf(';')
        if (ix !== -1) {
            version = version.substring(0, ix);
        }
        ix = version.indexOf(' ')
        if (ix !== -1) {
            version = version.substring(0, ix);
        }
        ix = version.indexOf(')')
        if (ix !== -1) {
            version = version.substring(0, ix);
        }

        // mobile version
        const mobile = /Mobile|mini|Fennec|Android|iP(ad|od|hone)/.test(nVer);

        // system
        let os = null;
        const clientStrings = [
            { s: 'Windows 10', r: /(Windows 10.0|Windows NT 10.0)/ },
            { s: 'Windows 8.1', r: /(Windows 8.1|Windows NT 6.3)/ },
            { s: 'Windows 8', r: /(Windows 8|Windows NT 6.2)/ },
            { s: 'Windows 7', r: /(Windows 7|Windows NT 6.1)/ },
            { s: 'Windows Vista', r: /Windows NT 6.0/ },
            { s: 'Windows Server 2003', r: /Windows NT 5.2/ },
            { s: 'Windows XP', r: /(Windows NT 5.1|Windows XP)/ },
            { s: 'Windows 2000', r: /(Windows NT 5.0|Windows 2000)/ },
            { s: 'Windows ME', r: /(Win 9x 4.90|Windows ME)/ },
            { s: 'Windows 98', r: /(Windows 98|Win98)/ },
            { s: 'Windows 95', r: /(Windows 95|Win95|Windows_95)/ },
            { s: 'Windows NT 4.0', r: /(Windows NT 4.0|WinNT4.0|WinNT|Windows NT)/ },
            { s: 'Windows CE', r: /Windows CE/ },
            { s: 'Windows 3.11', r: /Win16/ },
            { s: 'Android', r: /Android/ },
            { s: 'Open BSD', r: /OpenBSD/ },
            { s: 'Sun OS', r: /SunOS/ },
            { s: 'Chrome OS', r: /CrOS/ },
            { s: 'Linux', r: /(Linux|X11(?!.*CrOS))/ },
            { s: 'iOS', r: /(iPhone|iPad|iPod)/ },
            { s: 'Mac OS X', r: /Mac OS X/ },
            { s: 'Mac OS', r: /(Mac OS|MacPPC|MacIntel|Mac_PowerPC|Macintosh)/ },
            { s: 'QNX', r: /QNX/ },
            { s: 'UNIX', r: /UNIX/ },
            { s: 'BeOS', r: /BeOS/ },
            { s: 'OS/2', r: /OS\/2/ },
            { s: 'Search Bot', r: /(nuhk|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask Jeeves\/Teoma|ia_archiver)/ }
        ];
        for (const id in clientStrings) {
            const cs = clientStrings[id];
            if (cs.r.test(nAgt)) {
                os = cs.s;
                break;
            }
        }

        let osVersion = null;

        if (/Windows/.test(os)) {
            osVersion = /Windows (.*)/.exec(os)[1];
            os = 'Windows';
        }

        switch (os) {
            case 'Mac OS':
            case 'Mac OS X':
            case 'Android':
                osVersion = /(?:Android|Mac OS|Mac OS X|MacPPC|MacIntel|Mac_PowerPC|Macintosh) ([._\d]+)/.exec(nAgt)[1];
                break;
            case 'iOS':
                osVersion = /OS (\d+)_(\d+)_?(\d+)?/.exec(nVer);
                osVersion = osVersion[1] + '.' + osVersion[2] + '.' + (osVersion[3] || 0);
                break;
        }

        // get is touch device
        const isTouchDevice = window.matchMedia("(pointer: coarse)").matches

        // get system language
        const systemLanguage = navigator.language

        // get Device Type
        let deviceType: string;

        if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(nAgt)) {
            deviceType = "tablet";
        } else if (/Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(nAgt)) {
            deviceType = "mobile";
        } else {
            deviceType = "desktop";
        }
        return {
            device_id: binding && binding.deviceId || "unknown",
            device_model: binding && binding.deviceName || "unknown",
            os: osVersion || "unknown",
            os_version: os || "unknown",
            orientation: orientation || "unknown",
            display_resolution: screenSize || "unknown",
            is_mobile_device: mobile ? "true" : "false" || "unknown",
            browser_type: browser || "unknown",
            browser_version: version || "unknown",
            is_touch_device: isTouchDevice ? "true" : "false" || "unknown",
            system_language: systemLanguage || "unknown",
            device_type: deviceType || "unknown",
            keyboard_connection_type: "unknown",
            keyboard_type: "unknown",
            client_programming_language: "unknown",
            client_version: "unknown",
            session_id: "unknown",
            pointer_type: sessionStorage.getItem("pointer_type") || "unknown",
        }
    }
}

export default new LoginService()
